<template>
    <div class="infoBox animated slideInRight">
        <div class="topNode">
            <img :src="$t('lan.logo')" :class="lang==1 ? 'imgEn' : 'imgCn' "/>
            <span class="closeBtn show" @click="closeNav"></span>
        </div>
        <div class="navCon">
            <div class="nav" v-if="isLogin" :class="lang==1 ? 'en' : ''">
                <div class="title posn" >
                    <p class="top" @click="getPicList">{{$t('lan.creaImg')}}
                        <span class="btn show cur" :class="isPic ? 'up' : ''" ></span></p>
                    <ul class="cont" v-if="isPic">
                        <li v-for="(item,i) in listP" :key="i" :data-index="i" @click="pichref">{{ item }}</li>
                    </ul>
                </div>
                <div class="title posn"> 
                    <p class="top" @click="getVideoList">{{$t('lan.creaVideo')}}
                        <span class="btn show cur" :class="isVideo ? 'up' : ''" ></span>
                    </p>
                    <ul class="cont" v-if="isVideo">
                        <li v-for="(item,i) in listV" :key="i" :data-index="i" @click="videohref">{{ item }}</li>
                    </ul>
                </div>
                <div class="title" @click="log">{{$t('lan.logIn')}}</div>
                <div class="title" @click="reg">{{$t('lan.regIn')}}</div>
                <div class="title" @click="getBlue()">{{$t('lan.zhword')}}</div>
            </div>
            <div class="nav" :class="lang==1 ? 'en' : ''" v-else>
                <div class="title posn">
                    <p class="top" @click="getPicList">
                    hi {{ userInfo.userName}}
                    <span class="btn show cur" :class="isPic ? 'up' : ''" ></span>
                    </p>
                    <div v-if="lang==0">
                        <ul class="cont" v-if="isPic">
                            <li v-for="(item,i) in lognav" :key="i" :data-index="i" @click="myhref">{{ item }}</li>
                        </ul>
                    </div>
                    <div v-else>
                        <ul class="cont" v-if="isPic">
                            <li v-for="(item,i) in lognavE" :key="i" :data-index="i" @click="myhref">{{ item }}</li>
                        </ul>
                    </div>
                </div>
                <div class="title posn" @click="toBrose()">
                    {{$t('lan.recently')}}
                </div>
                <!-- <div class="title" @click="toSerImg(1)">{{$t('lan.creaImg')}}</div>
                <div class="title" @click="toSerImg(2)">{{$t('lan.creaVideo')}}</div> -->
                <div class="title posn" >
                    <p class="top" @click="getMylist(1)">{{$t('lan.creaImg')}}
                        <span class="btn show cur" :class="isImgNav ? 'up' : ''" ></span></p>
                    <ul class="cont" v-if="isImgNav">
                        <li v-for="(item,i) in listP" :key="i" :data-index="i" @click="pichref">{{ item }}</li>
                    </ul>
                </div>
                <div class="title posn"> 
                    <p class="top" @click="getMylist(2)">{{$t('lan.creaVideo')}}
                        <span class="btn show cur" :class="isVideoNav ? 'up' : ''" ></span>
                    </p>
                    <ul class="cont" v-if="isVideoNav">
                        <li v-for="(item,i) in listV" :key="i" :data-index="i" @click="videohref">{{ item }}</li>
                    </ul>
                </div>
                <div class="title" @click="getBlue()">{{$t('lan.zhword')}}</div>
                <div class="title" @click="logout()">{{$t('lan.signOut')}}</div>
            </div>
        </div>
        
		<logBox v-if="isLog" @closeType="closeType" @closeED = "closed(1)" ></logBox>
        <regBox v-if="isReg" @closeType="closeType" @closeED = "closed(2)"></regBox>
        <pwdBox v-if="isPwd" @closePwd="closePwd" @closeED = "closed(3)"></pwdBox>
        <pwdTwo v-if="isPwdTwo" :dataJson="dataJson" @closeType="closeType" @closeReg = "closeds"></pwdTwo>
        <pwdThree v-if="isPwdThree" @closeType="closeType" @closeReg = "closeds"></pwdThree>
        <regInfoBox v-if="isInfo" @closeType="closeType" @closeReg = "closeds"></regInfoBox>
    </div>
</template>

<script>
import logBox from './logTog.vue';
import regBox from './regTog.vue';
import pwdBox from './pwd.vue';
import pwdTwo from './pwdTwo.vue';
import pwdThree from './pwdThree.vue';
import regInfoBox from './regInfo.vue';
import { mapGetters,mapMutations } from 'vuex';
export default {
    name: 'app',
    components: {
        logBox,
        regBox,
        pwdBox,
        pwdTwo,
        pwdThree,
        regInfoBox,
    },
    props:{

    },
    data(){
        return {
            lang: window.location.href.indexOf('bluejeanimages')>0 ? 1 : 0,
            isPic:true,
            isVideo:true,
            listP:[this.$t('lan.browallimg'),this.$t('lan.newline'),this.$t('lan.bycateg'),this.$t('lan.editTj')],
            listV:[this.$t('lan.browallvideo'),this.$t('lan.newlineV')],
            isLog:false,
            isReg:false,
            isPwd:false,
            isPwdTwo:false,
            isPwdThree:false,
            isInfo:false,
            lognav:['账户','收藏夹','购物车','订单','下载'],
            lognavE:['My Account','Lightboxe','My Cart','Order','Download'],
            isLogin:true,
            keyword:'',
            dataJson:'',
            isImgNav:false,
            isVideoNav:false,
        }
    },
    created() {
        
    },
    mounted(){
		console.log(this.userInfo)
        if(this.userInfo){
            this.isLogin = false;
			console.log(this.isLogin)
			this.getUserInfo();
        }
        
    },
    destroyed(){
    
    },
    methods:{
		...mapMutations([
		    'setSerchCon',
		]),
        getPicList(){
            this.isPic=!this.isPic;
        },
        getVideoList(){
            this.isVideo=!this.isVideo;
        },
        getMylist(type){
            if(type==1){
                this.isImgNav=!this.isImgNav;
            }else{
                this.isVideoNav=!this.isVideoNav;
            }
            
        },
        pichref(event){
            var currenIndex = event.target.dataset.index;
            console.log("currenIndex ：" + currenIndex)
            if(currenIndex==0){
				this.setSerchCon({
					type : 1,
					keyword: ''
				})
                this.$router.push({ path:'/search'})
            }else if(currenIndex==1){
				this.setSerchCon({
					type : 3,
					keyword: ''
				})
                this.$router.push({ path:'/search' })
            }else if(currenIndex==2){
                this.$router.push({ path:'/classify' })
            }else if(currenIndex==3){
                this.$router.push({ path:'/recommend' })
            }
            this.$emit('closeBox','1');
        },
        myhref(event){
            var currenIndex = event.target.dataset.index;
            console.log("currenIndex ：" + currenIndex)
            if(currenIndex==0){
                this.$router.push({ path:'/account' })
            }else if(currenIndex==1){
                this.$router.push({ path:'/favorite' })
            }else if(currenIndex==2){
                this.$router.push({ path:'/shopcart' })
            }else if(currenIndex==3){
                this.$router.push({ path:'/order' })
            }else{
                this.$router.push({ path:'/download' })
            }
            this.$emit('closeBox','1');
        },
        videohref(event){
            var currenIndex = event.target.dataset.index;
            console.log("currenIndex ：" + currenIndex)
            if(currenIndex==0){
                var type = 2;
            }else{
                var type = 4;
            }
			this.setSerchCon({
				type : type,
				keyword: ''
			})
			this.$router.push({ path:'/search'})
            this.$emit('closeBox','1')
        },
        toSerImg(type){
            if(type==1){
                var type = 1;
            }else{
                var type = 2;
            }
			this.setSerchCon({
				type : type,
				keyword: ''
			})
			this.$router.push({ path:'/search'})
            this.$emit('closeBox','1')
        },
        //最近浏览
        toBrose(){
            this.$router.push({ path:'/browse' })
        },
        getBlue(type){
            var href=window.location.href;
            if(href.indexOf('lanniuzai')>0){
                href=href.replace('lanniuzai','bluejeanimages');
                window.location.href=href;
            }else if(href.indexOf('bluejeanimages')>0){
                href=href.replace('bluejeanimages','lanniuzai');
                window.location.href=href;
            }
        
        },
        log(){
            this.isLog=true;
        },
        reg(){
            this.isReg=true;
        } ,
        closed(type){
            if(type==1){
                this.isLog=false;
            }else if(type==2){
                this.isReg=false;
            }else{
                this.isPwd = false;
            }
            this.getUserInfo();
        }, 
        //获取用户信息
        getUserInfo(){
			let _this = this;
			_this.$api.getAccount().then((res)=>{
                if(res.result==1){
                    this.setUserInfo(res.resultMsg);
                    this.isLogin=false;
                }
            }).catch((err)=>{
                this.isLogin=true;
                console.log(err) 
            })
        },
        closeds(val){
            this.isReg = false;
        },
        closeNav(){
            this.$emit('closeBox','0')
        } ,
        closeType(val){
            this.isLog=false;
            this.isReg=false;
            this.isPwd=false;
            this.isPwdTwo=false;
            this.isPwdThree=false;
            if(val==2){
                this.isReg=true;
            }else if(val==1){
                this.isLog=true;
            }else if(val==3){
                this.isPwd=true;
            }else if(val==4){
                this.isPwdTwo=true;
            }else if(val==5){
                this.isPwdThree=true;
            }
        },
        closePwd(obj){
            this.dataJson=obj;
            this.isPwdTwo=true;

        },
        //退出
        async logout(){
			let _this = this;
			this.$store.dispatch("LogOut").then(res => {
			    this.isLogin=true;
			    this.$emit('closeBox','1');
			})
			.catch((error) => {
			    
			});
        }
    }
}
</script>
<style lang="scss" scoped>
    .infoBox{
      width:750px;
      margin:0 auto;
      background:rgba(#404040,.9);
      height:100%;
      position: fixed;
      top:0;
      left: 0;
      z-index: 2000;
      .topNode{
       // background:#fff;
        height:108px;
        width:100%;
        background:#404040;
        .imgEn{
          width:315px;
          height:68px;
          margin:20px 30px;
        }
        .imgCn{
          width:405px;
          height:68px;
          margin:20px 30px;
        }
        .closeBtn{
          background:url(../assets/wap/icon_closeW.png) no-repeat; 
          background-size:35px 35px;
          width:35px;
          height:35px;
          position: absolute;
          right:30px;
          top:34px;
        }
      }
    }
    .navCon{
        width:100%;
        height:calc(100vh - 108px);
        overflow-y: scroll;
    }
    .nav{
      width:100%;
      background: #0099e5;
      overflow: auto;
      height:auto;
      
      zoom: 1;
      color:#fff;
      .clik{
        color:#005580;
      }
      .title{
        min-height:98px;
        border-top:solid 1px #00a7fd;
        line-height:98px;
        font-size:28px;
        text-align: center;
        letter-spacing: 5px;
        height:auto;
        overflow: auto;
        zoom: 1;
        .top{
            width:100%;
            //height:98px;
            background: #0099e5;
        }
        .btn{
          width:98px;
          height:98px;
          position: absolute;
          right:0;
          top:0;
          border-left:solid 1px #00a7fd;
          background:url(../assets/wap/icon_on.png) no-repeat center center; 
          background-size:20px 13px;
        }
        .btn.up{
          background:url(../assets/wap/icon_up.png) no-repeat center center; 
          background-size:20px 13px;
        }
        .cont{
          //position: absolute;
         // left:0;
         // top:98px;
          width:100%;
          line-height:98px;
          background: #0080bf;
          li{
            border-top:solid 1px #00a7fd;
            height:98px;
            width:100%;
            text-align:center;
          }
        }
      }
      
    }
    .en{
      .title{
        letter-spacing: 1px;
      }
    }
    
</style>
